import React from "react";
import { MdClose } from "react-icons/md";

const Prequa_Desc_Modal = ({ desc, closeModal, header }) => {
  return (
    <div
      id="modal"
      className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center  bg-gray-800 bg-opacity-70 transform scale-100 transition-transform duration-300 z-1000"
    >
      <div className="bg-white w-1/2  rounded-sm max-h-[400px] overflow-auto">
        <div className="bg-white w-full sticky top-0 p-4 shadow-2 ">
          <div className="flex justify-between  ">
            <div className="flex justify-center">
              <h1 className="text-base md:text-2xl font-semibold text-center">
                {header}
              </h1>
            </div>

            <button
              id="closebutton"
              type="button"
              className="focus:outline-none"
              onClick={closeModal}
            >
              <MdClose className="w-6 h-6" />
            </button>
          </div>
        </div>

        <div className="mt-2 m-4">
          <p className="font-medium text-sm md:text-base whitespace-pre-line">
            {desc}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Prequa_Desc_Modal;
